import Vue from 'vue'

import config from '../config'

Vue.prototype.$getImg = url => {
  return `${config.apiBase}${url}`
}

Vue.prototype.$bgImg = url => {
  return {
    backgroundImage: `url(${Vue.prototype.$getImg(url)})`
  }
}
